/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { APIErrorSchema } from "./APIErrorSchema.ts"
import { z } from "zod/v4"

export const approveFollowRequestPathParamsSchema = z.object({
  requestId: z.string(),
})

/**
 * @description Successfully approved a follow request
 */
export const approveFollowRequest200Schema = z.object({
  message: z.string(),
})

/**
 * @description The \"Authorization\" header does not contain a valid Bearer access token.
 */
export const approveFollowRequest401Schema = APIErrorSchema

/**
 * @description Not authorized to approve this request
 */
export const approveFollowRequest403Schema = APIErrorSchema

/**
 * @description Request not found
 */
export const approveFollowRequest404Schema = APIErrorSchema

export const approveFollowRequestMutationRequestSchema = z.object({
  protectedProfileSymmetricKey: z.string(),
})

export const approveFollowRequestMutationResponseSchema =
  approveFollowRequest200Schema
